import { create } from 'zustand';
import { Language, getUserLanguage, isRTL, t, TranslationKey } from '../i18n/translations';

interface LanguageState {
  language: Language;
  isRtl: boolean;
  t: (key: TranslationKey, vars?: Record<string, string | number>) => string;
  setLanguage: (lang: Language) => void;
}

export const useLanguage = create<LanguageState>((set, get) => ({
  language: getUserLanguage(),
  isRtl: isRTL(getUserLanguage()),
  t: (key: TranslationKey, vars?: Record<string, string | number>) => t(get().language, key, vars),
  setLanguage: (lang: Language) => set({ language: lang, isRtl: isRTL(lang) }),
}));
